import { useMutation } from "react-query";
import { ContaRecorrenteRequestData } from "../typings";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useSaveContaRecorrente() {
  return useMutation(
    async (form: ContaRecorrenteRequestData) => {

      if (form.id) {
        return http.put<{id: string}>(`/v1/conta-recorrente/${form.id}`, form);
      }

      const { data } = await http.post<{id: string}>(`/v1/conta-recorrente`, form);

      return data;
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useSaveContaRecorrente;
